import { type Theme } from '@mui/material';

// @tgtg/kit's Modal portals to <body> (data-rac), missing theme.zIndex.modal, so it'd render behind the drawer without body >.
export const kitOverrides = (theme: Omit<Theme, 'components'>) => `
body > [data-rac]:has([role='dialog'], [role='alertdialog']) {
	z-index: ${theme.zIndex.modal};
}
`;
